import check from "../../images/hireDeveloper/check.svg";
import userQuestions from "../../images/hireDeveloper/user-questions.svg";
import android from "../../images/home/technology/android.svg";
import angular from "../../images/home/technology/angular.svg";
import apple from "../../images/home/technology/apple.svg";
import dotnet from "../../images/home/technology/dotnet.svg";
// import flutter from "../../images/home/technology/flutter.svg";
import nodejs from "../../images/home/technology/nodejs.svg";
import laravel from "../../images/home/technology/laravel.svg";
import react from "../../images/home/technology/react.svg";
// import xamarin from "../../images/home/technology/xamarin.svg";
import vuejs from "../../images/home/technology/vuejs.svg";
import reactnative from "../../images/home/technology/reactnative.svg";
import python from "../../images/home/technology/python.svg";
import ai from "../../images/home/technology/ai.svg";
import uiux from "../../images/home/technology/uiux.svg";

export const skillData = [
  {
    id: 0,
    images: ai,
    name: "AI",
    altText: "AI"
  },
  {
    id: 1,
    images: python,
    name: "Python",
    altText: "Python"
  },
  {
    id: 2,
    images: dotnet,
    name: ".Net Core",
    altText: ".Net Core"
  },
  {
    id: 3,
    images: react,
    name: "React",
    altText: "React Development"
  },
  {
    id: 4,
    images: nodejs,
    name: "Node.js",
    altText: "Node.js Development"
  },
  {
    id: 5,
    images: angular,
    name: "Angular",
    altText: "Angular Development"
  },

    {
    id: 6,
    images: laravel,
    name: "Laravel",
    altText: "Laravel Development"
  },
    {
    id: 7,
    images: reactnative,
    name: "React Native",
    altText: "React Native Development"
  },

  {
    id: 8,
    images: apple,
    name: "iOS",
    altText: "iOS App Development"
  },
  {
    id: 9,
    images: android,
    name: "Android",
    altText: "Android App Development"
  },
    {
    id: 10,
    images: uiux,
    name: "UI/UX",
    altText: "UI/UX Design"
  },
  {
    id: 11,
    images: userQuestions,
    name: "Other Tech!",
    altText: "Custom Software Development"
  },
];

export const experience = [
  { id: 0, value: "less3", label: "Less Than 3 Years" },
  { id: 1, value: "3to5", label: "3 To 5 Years" },
  { id: 2, value: "more5", label: "More Than 5 Years" },
];

export const startwork = [
  { id: 0, value: "as_soon_as_possible", label: "As Soon As Possible" },
  { id: 1, value: "1to2_weeks", label: "1 To 2 Weeks" },
  { id: 2, value: "2+_weeks", label: "2+ Weeks" },
  { id: 3, value: "not_decided", label: "Not Decided" },
];

export const longwork = [
  { id: 0, value: "less_1_month", label: "<1 Month" },
  { id: 1, value: "1to3_months", label: "1 To 3 Months" },
  { id: 2, value: "3to6_months", label: "3 To 6 Months" },
  { id: 3, value: "6_plus_months", label: "6+ Months" },
  { id: 4, value: "other", label: "Other" },
];
